// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"2dd18049","158":"a2d82df8","164":"6799395b","206":"46338a0b","269":"bc8c7db4","543":"6b2564f9","604":"31d6cfe0","639":"1632d3bf"}[chunkId] + ".chunk.css";
};